import './SubHeading.css';

const SubHeading = ({ text }) => (
  <div className="sub-heading">
    <p>{text}</p>
  </div>
);

export default SubHeading;
